<template>
    <analytics-stat-card
        :loading="loading"
        :error="Boolean(error)"
        :difference="dataComputed.difference"
        :value="dataComputed.number?.value"
        :color="dataComputed.difference > 0 ? 'bad' : 'good'"
        :direction="dataComputed.difference < 0 ? 'down' : 'up'"
    >
        <template v-slot:title>
            <slot name="title"> New Unsubscribers </slot>
        </template>
        <template v-slot:subtitle>
            <slot name="subtitle"></slot>
        </template>

        <span>{{ dataComputed.number?.label || '' }}</span>

        <template v-slot:explainHeader><slot name="explainHeader">Unsubscribers</slot></template>
        <template v-slot:explainContent>
            <slot name="explainContent">
                <p>
                    <strong>New Unsubscribers</strong><br />
                    Gross Increase Count of Contacts that have explicitly denied receiving marketing messages, during
                    the selected period.
                </p>

                <p>
                    <strong>New Unsubscribers %</strong><br />
                    Gross Increase Percent of Contacts that have explicitly denied receiving marketing messages, during
                    the selected period relative to the previous period.
                </p>

                <vx-button href="/contacts" size="sm" color="muted">
                    Go to Contacts
                    <font-awesome-icon widthAuto :icon="faArrowRight"></font-awesome-icon>
                </vx-button>
            </slot>
        </template>
    </analytics-stat-card>
</template>
<script setup>
import { analyticsClient } from '~/services';
import { computed, watch } from 'vue';
import AnalyticsStatCard from '../../partial/AnalyticsStatCard.vue';
import { VxButton } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { calculateDifference, computeComparisonRange } from '../../../../utils/analytics';
import { useVersionedRequest } from '~/composables/useVersionedRequest';
import { formatCount } from '~/components/filters';

const props = defineProps({
    startDate: {
        type: String,
        required: true,
    },
    endDate: {
        type: String,
        required: true,
    },
    orgUnitId: {
        type: Number,
    },
    groupId: {
        type: String,
    },
    type: {
        type: String,
        default: undefined,
        validator: (type) => ['affiliated', 'preferred'].includes(type),
    },
});

const { loading, response, error, fetchData } = useVersionedRequest();

const dataComputed = computed(() => {
    const responseData = response.value?.data;

    if (!responseData?.values?.length) {
        return {
            number: undefined,
            difference: undefined,
        };
    }

    const number = responseData.values.length >= 2 ? responseData.values[1] : responseData.values[0];
    const difference = responseData.values.length >= 2 ? calculateDifference(responseData.values) : undefined;

    return {
        number: {
            value: number,
            label: formatCount(number),
        },
        difference: difference,
    };
});

watch(
    [() => props.startDate, () => props.endDate],
    () => {
        const params = {
            range: computeComparisonRange({ start: props.startDate, end: props.endDate }, Boolean(props.groupId)),
        };

        fetchData(
            analyticsClient.getMarketingSubscriptionsTotalOptOuts(
                {
                    teamId: Spark.state.currentTeam.id,
                    orgUnitId: props.orgUnitId,
                    groupId: props.groupId,
                },
                params,
                props.type
            )
        ).catch((e) => {
            console.error(e);
        });
    },
    { immediate: true }
);
</script>
